import LocalStorage from '../../utils/commonFunction/LocalStorage'
const axios = require('axios').default;


export default class Networking {
    static PostAxios(url, data = '', token) {
        var config = {}
        config = {
            method: 'Post',
            url: url,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`,
            },
            data: data
        };

        return axios(config)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                console.log("error", error)
                // if ((error.message != undefined && error.message.toLowerCase().includes("network")) || error?.response?.status === 405) {
                //     // localStorage.clear();
                //     // window.location.href = "/";
                // }
                // else {
                if (error.response) {
                    if (error.response.status === 405 || error.response.status === 401) {
                        // localStorage.clear();
                        LocalStorage.removeItem("user");
                        LocalStorage.removeItem("fromDate")
                        LocalStorage.removeItem("toDate")
                        LocalStorage.removeItem("IsHoliday")
                        LocalStorage.removeItem('paymentdetails')
                        LocalStorage.removeItem('licenseMsg')
                        LocalStorage.removeItem("userListActive")
                        LocalStorage.removeItem("userListUnauthorized")
                        LocalStorage.removeItem("userListTrakZoLite")
                        LocalStorage.removeItem("userListInActive")
                        window.location.href = "/";
                    } else {
                        return {
                            status: error.response.status,
                            message: error.toString()
                        }
                    }
                    // console.log(error.response.data);
                    // console.log(error.response.status);
                    // console.log(error.response.headers);
                } else {
                    if (error instanceof Error) {
                        return {
                            status: 401,
                            message: error.toString()
                        }
                    }
                }
                // }
                return error.json().then((responseJson) => {

                    return {
                        error: new Error(
                            `HTTP ${error.status} ${error.statusText}: ${responseJson.msg}`
                        )
                    }
                })
            });
    }

    static GetAxios(url, data = '', token) {
        var config = {}
        config = {
            method: 'get',
            url: url,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`,
            },
            // data: data
        };

        return axios(config)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                if (error.response) {
                    if (error.response.status === 405 || error.response.status === 401) {
                        localStorage.clear();
                        window.location.href = "/";
                    } else {
                        return {
                            status: error.response.status,
                            message: error.toString()
                        }
                    }
                    // console.log(error.response.data);
                    // console.log(error.response.status);
                    // console.log(error.response.headers);
                } else {
                    if (error instanceof Error) {
                        return {
                            status: 401,
                            message: error.toString()
                        }
                    }
                }


                return error.json().then((responseJson) => {

                    return {
                        error: new Error(
                            `HTTP ${error.status} ${error.statusText}: ${responseJson.msg}`
                        )
                    }
                })
            });
    }

    static PostAxiosWithoutToken(url, data = '') {
        var config = {}
        config = {
            method: 'post',
            url: url,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            data: data
        };

        return axios(config)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                if (error instanceof Error) {
                    return {
                        status: 401,
                        message: error.toString()
                    }
                }

                return error.json().then((responseJson) => {

                    return {
                        error: new Error(
                            `HTTP ${error.status} ${error.statusText}: ${responseJson.msg}`
                        )
                    }
                })
            });
    }
}